import { Checkbox } from '@designsforhealth/dfh-react-components'
import React, { FC, useState } from 'react'
import { UseFormMethods } from 'react-hook-form'
import { TermsModal } from '../../terms/TermsModal'
import { TermsLinkComponent, TermsModalType } from '../../terms/types'
import * as Styled from './styled'

export interface RegistrationFormSimpleTermsProps {
  register: UseFormMethods['register']
  linkComponents: TermsLinkComponent[]
}

export const RegistrationFormSimpleTerms: FC<RegistrationFormSimpleTermsProps> = ({
  linkComponents: LinkComponents,
  register,
}) => {
  const [currentlyOpenTermsModal, setCurrentlyOpenTermsModal] = useState<TermsModalType | null>(
    null
  )

  return (
    <div>
      <TermsModal
        currentlyOpenTermsModal={currentlyOpenTermsModal}
        open={!!currentlyOpenTermsModal}
        setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
      />
      <Styled.CheckboxWrapper>
        <Checkbox
          label={
            <div data-cy="terms-and-conditions">
              By entering my information and using the site, I agree to the{' '}
              {LinkComponents.map((LinkComponent, index, array) => (
                <React.Fragment key={index}>
                  {index > 0 && array.length === 2 && ' '}
                  {index > 0 && array.length > 2 && ', '}
                  {index > 0 && index === array.length - 1 && 'and '}
                  <LinkComponent setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal} />
                </React.Fragment>
              ))}
            </div>
          }
          id="termsandconditions"
          name="termsandconditions"
          register={register}
          value=""
          defaultChecked={false}
        />
      </Styled.CheckboxWrapper>
    </div>
  )
}
